module.exports = "<div class=\"c-email\">\n    <div class=\"c-email__wrapper\">\n        <div ng-bind-html=\"$ctrl.loadContent()\"></div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/order/views/email.content.html
// module id = 790
// module chunks = 0